const API_ROOT = String(import.meta.env.VITE_API_URL || "").replace(/\/$/, "");

export class ApiError extends Error {
  constructor(message: string, readonly status: number) {
    super(message);
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  const multipart = typeof FormData !== "undefined" && init.body instanceof FormData;
  if (init.body && !multipart && !headers.has("Content-Type")) headers.set("Content-Type", "application/json");
  const response = await fetch(`${API_ROOT}/api${path}`, {
    cache: "no-store",
    ...init,
    headers,
    credentials: "include",
  });
  const data = await response.json().catch(() => ({})) as { message?: string; error?: string };
  if (!response.ok) {
    const message = Array.isArray(data.message) ? data.message.join(" ") : data.message || data.error || "Nao foi possivel concluir a operacao.";
    throw new ApiError(String(message), response.status);
  }
  return data as T;
}

export function jsonBody(value: unknown): Pick<RequestInit, "body" | "headers"> {
  return {
    body: JSON.stringify(value),
    headers: { "Content-Type": "application/json" },
  };
}
